import React from "react";
import Badge from "@material-ui/core/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import Popover from "@material-ui/core/Popover";
import ModalListaFiltrosQuienes from "./modalListaFiltrosQuienes";
import ListarFiltrosQuienes from "./listarFiltrosQuienes";
import ConfigurarFiltroQuienes from "./cofigurarFiltroQuienes/cofigurarFiltroQuienes";

function FiltrosQuienes(props) {
  const [ancla, setAncla] = React.useState();
  const [filtroActual, setFiltroActual] = React.useState(null);
  const [vistaactiva, setVistaactiva] = React.useState(0);
  const [switchIncluidos, setSwitchIncluidos] = React.useState(true);
  const [redactiva, setRedActiva] = React.useState();
  React.useEffect(() => {
    const x = vistaactiva;
    setVistaactiva(3);
    setVistaactiva(x);
  }, [props.actualizarlista]);
  const Mostrarvista = () => {
    if (vistaactiva === 0) {
      return (
        <ModalListaFiltrosQuienes
          setSwitchIncluidos={setSwitchIncluidos}
          eliminarfiltro={props.eliminarfiltro}
          listadefiltros={props.listadefiltros}
          setVistaactiva={setVistaactiva}
          setRedActiva={setRedActiva}
          laredactiva={redactiva}
        />
      );
    }
    if (vistaactiva === 1) {
      return (
        <ListarFiltrosQuienes
          setFiltroActual={setFiltroActual}
          quienesactual={props.quienesactual}
          setVistaactiva={setVistaactiva}
        />
      );
    }
    if (vistaactiva === 2) {
      return (
        <ConfigurarFiltroQuienes
          switchIncluidos={switchIncluidos}
          agregarFiltro={props.agregarFiltro}
          filtroActual={filtroActual}
          quienesactual={props.quienesactual}
          setVistaactiva={setVistaactiva}
          redactiva={redactiva}
        />
      );
    }
    if (vistaactiva === 3) {
      return <div></div>;
    }
  };

  return (
    <>
      <Badge
        style={{
          position: "absolute",
          alignSelf: "center",
          background: "#fff",
          cursor: "pointer",
        }}
        color="secondary"
        badgeContent={0}
        onClick={(event) => {
          setAncla(event.currentTarget);
          setVistaactiva(0);
        }}
      >
        <FontAwesomeIcon
          style={{
            fontSize: 20,
            color: "#000",
          }}
          icon={faDoorClosed}
        />
      </Badge>
      <Popover
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={0}
        id="popov"
        placement="top-start"
        anchorEl={ancla}
        open={Boolean(ancla)}
        onClose={() => {
          setAncla(null);
        }}
      >
        <div
          style={{
            background: "#fff",
            marginTop: 10,
            padding: 15,
            borderRadius: 5,
            borderColor: "rgb(232 232 232)",
            borderStyle: "solid",
            borderWidth: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 250,
            minHeight: 250,
          }}
        >
          <Mostrarvista />
        </div>
      </Popover>
    </>
  );
}

export default FiltrosQuienes;
